export default __webpack_public_path__ + "static/media/magnifier.6c528985.svg";